import { IGpsItem, IMoveTracker } from '@nkr/models/index';

export interface IInProcessSwap extends IMoveTracker {
    gpsResults: IGpsItem[]
}